import { createContext, useState, useContext } from 'react';

const defaultState = {
  row: -1,
  column: -1,
};
export const TableHighlightContext = createContext({
  ...defaultState,
});

export const TableHighlightProvider = ({ children }) => {
  const [highlightedCell, setHighlightedCell] = useState({
    ...defaultState,
  });
  const highlighting = highlightedCell.row !== -1;

  return (
    <TableHighlightContext.Provider
      value={{ highlightedCell, setHighlightedCell, highlighting }}
    >
      {children}
    </TableHighlightContext.Provider>
  );
};

export const useHighlightContext = () => useContext(TableHighlightContext);
